module.exports = __webpack_public_path__ + "static/media/angieveguilla-10.1fa19e65.jpg";